export * from './OfferingsServiceApiClient';

export type {
  APIClientConfig,
  APIRequestOptions,
} from './OfferingsServiceApiClient';

export type {
  DegreeFieldsConfig,
  Dimension,
  DimensionNode,
  DimensionsResponse,
  ExactOfferingResponse,
  Filters,
  Offering,
  OfferingPayload,
  OfferingResponse,
  OfferingsSearchPayload,
  OfferingsSearchResponse,
  Question,
  RankingOfferingsPayload,
  RankingOfferingsResponse,
  RecommendationsResponse,
} from './offeringsServiceSchema';

export { DimensionsResponseSchema } from './offeringsServiceSchema';
